import { PieChartData } from "@evergis/charts";

import { FEATURE_CARD_DEFAULT_COLORS, FEATURE_CARD_OTHER_COLOR } from "../constants";
import { i18n } from "../../../i18n";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild } from "../types";

export const getDataFromAttributes = (
  config: ConfigContainerChild,
  attributes?: FeatureAttribute[],
): PieChartData[] => {
  const { options, children } = config || {};
  const colors = options?.colors || FEATURE_CARD_DEFAULT_COLORS;
  const defaultColor = options?.defaultColor || FEATURE_CARD_OTHER_COLOR;

  const data: PieChartData[] = children?.map(({ attributeName }, index) => {
    const attribute = attributes?.find(({ name }) => name === attributeName);

    return {
      name: attribute?.name || "",
      value: attribute ? Number(attribute.value) : 0,
      color: colors[index] || defaultColor,
    };
  });

  if (options?.orderByValue) {
    data.sort((a, b) => (b.value as number) - (a.value as number));
  }

  const isOtherSliced = options?.otherItems && options.otherItems < data.length;

  if (!isOtherSliced) return data;

  const otherValue = data.slice(0, options?.otherItems).reduce((prev, { value }) => prev + (value as number), 0);

  return [
    ...data?.slice(0, options?.otherItems),
    {
      name: i18n.t("classification.other", { ns: "common" }),
      color: defaultColor,
      value: Number(otherValue),
    },
  ];
};
